module.exports = __webpack_public_path__ + "static/media/pen.e75b09f5.svg";